import { TgAccountsI } from "@services/getTgAccounts";
import {
  IAccount,
  NotificationsEmails,
} from "@services/http/responses/AccountResponse";
import {
  ActionBaseMe,
  ActionSetMe,
  ActionSetNotifsEmails,
  ActionSetPoolDivider,
  ActionSetPoolSettings,
  ActionSetTgAccounts,
  ActionTypesMeE,
  ActionUpdateMe,
  PoolDivider,
  IStoredSetting,
  ActionAddPoolSetting,
  ActionDeletePoolSetting,
  ActionEditPoolSetting,
  ActionSetMeLoaders,
  ActionSetMeta,
} from "./actionTypes";
import { UserMeta } from "@services/editUser";

export function setMe(accData: IAccount): ActionSetMe {
  return {
    type: ActionTypesMeE.SET_ME,
    payload: { accData },
  };
}

export function updateMe(accData: IAccount): ActionUpdateMe {
  return {
    type: ActionTypesMeE.UPDATE_ME,
    payload: { accData },
  };
}

export function setPoolSettings(
  poolSettings: IStoredSetting[]
): ActionSetPoolSettings {
  return {
    type: ActionTypesMeE.SET_POOL_SETTINGS,
    payload: {
      poolSettings,
      // poolSettings: poolSettings.sort((a, b) => a.name.localeCompare(b.name)),
    },
  };
}

export function addPoolSetting(
  poolSetting: IStoredSetting
): ActionAddPoolSetting {
  return {
    type: ActionTypesMeE.ADD_POOL_SETTING,
    payload: poolSetting,
  };
}

export function editPoolSetting(
  poolSetting: IStoredSetting
): ActionEditPoolSetting {
  return {
    type: ActionTypesMeE.EDIT_POOL_SETTING,
    payload: poolSetting,
  };
}

export function deletePoolSetting(id: number): ActionDeletePoolSetting {
  return {
    type: ActionTypesMeE.DELETE_POOL_SETTING,
    payload: id,
  };
}

export function setPoolDivider(
  poolDivider: PoolDivider[]
): ActionSetPoolDivider {
  return {
    type: ActionTypesMeE.SET_POOL_DIVIDER,
    payload: {
      poolDivider,
    },
  };
}
export function clearMe(): ActionBaseMe {
  return {
    type: ActionTypesMeE.CLEAR_ME,
  };
}

export function setNotifsEmeils(
  emails: NotificationsEmails[]
): ActionSetNotifsEmails {
  return {
    type: ActionTypesMeE.SET_NOTIFS_EMAILS,
    payload: { emails },
  };
}

export function setTgAccounts(tgAccounts: TgAccountsI[]): ActionSetTgAccounts {
  return {
    type: ActionTypesMeE.SET_TG_ACCOUNTS,
    payload: { tgAccounts },
  };
}

export function setMeLoaders(payload: ActionSetMeLoaders["payload"]) {
  return {
    type: ActionTypesMeE.SET_LOADERS,
    payload,
  };
}

export function setMeta(m: UserMeta): ActionSetMeta {
  return {
    type: ActionTypesMeE.SET_META,
    payload: m,
  };
}
